import { AccountRow } from '~/app/accounts/types'
import { AddressDisplay } from '~/components/component-library'

export const AutomationAccountDestination = ({
  account,
}: {
  account: AccountRow
}) => {
  if (!account.automation) return null

  return (
    <AddressDisplay
      address={account.automation.policy.passThroughDestinationAddress}
      layout="standard"
      isInternal
    />
  )
}
